import React, { Fragment } from 'react';

// MUI Icons
import {
  ArrowForward,
  Diamond,
  Add,
  Chat,
  Star,
  RadioButtonChecked,
  ArrowUpward
} from '@mui/icons-material';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Drawer,
  IconButton,
  Box,
  Checkbox,
  Badge,
  Button,
  List,
  ListItem,
  Tooltip,
  Divider,
  Typography,
  CircularProgress
} from '@mui/material';

import avatar1 from '../../assets/images/avatars/avatar1.jpg';
import avatar2 from '../../assets/images/avatars/avatar2.jpg';
import avatar6 from '../../assets/images/avatars/avatar6.jpg';
import avatar7 from '../../assets/images/avatars/avatar7.jpg';

import MenuOpenRoundedIcon from '@mui/icons-material/MenuOpenRounded';

import ListIcon from '@mui/icons-material/List';

import CountUp from 'react-countup';
// Chart component removed

function HeaderDrawer() {
  const chart36Options = {
    chart: {
      toolbar: {
        show: false
      },
      sparkline: {
        enabled: true
      }
    },

    stroke: {
      color: '#1bc943',
      curve: 'smooth',
      width: 4
    },
    colors: ['#1bc943'],
    fill: {
      color: '1bc943',
      gradient: {
        shade: 'light',
        type: 'vertical',
        shadeIntensity: 0.7,
        inverseColors: true,
        opacityFrom: 1,
        opacityTo: 0,
        stops: [0, 100]
      }
    },
    xaxis: {
      crosshairs: {
        width: 1
      }
    },
    yaxis: {
      min: 0
    }
  };
  const chart36Data = [
    {
      name: 'Monthly Analytics',
      data: [47, 38, 56, 24, 45, 54, 38, 56, 24, 65]
    }
  ];

  const [open, setOpen] = React.useState(false);

  function handleDrawerClose() {
    setOpen(true);
  }

  function handleDrawerOpen() {
    setOpen(false);
  }

  return (
    <Fragment>
      <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
        {/* <Box className="ml-2">
          <Tooltip title="Toggle Drawer" placement="right">
            <IconButton
              color="inherit"
              onClick={handleDrawerClose}
              size="medium"
              className="btn-inverse">
              {open ? <MenuOpenRoundedIcon /> : <ListIcon />}
            </IconButton>
          </Tooltip>
        </Box> */}
        <Drawer
          anchor="right"
          open={open}
          variant="temporary"
          elevation={4}
          onClose={handleDrawerOpen}>
          <Box className="app-header-drawer">
            <PerfectScrollbar>
              <div className="p-4">
                <div className="text-center">
                  <div className="font-weight-bold font-size-lg mb-0 text-black">
                    Today's sales target
                  </div>
                  <p className="text-black-50">
                    Daily statistics regarding your sales targets
                  </p>
                </div>
                <div className="rounded p-4 text-white bg-deep-sky">
                  <div className="d-flex mb-3 justify-content-center">
                    <Box
                      sx={{
                        position: 'relative',
                        width: 160,
                        height: 160,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      <CircularProgress
                        variant="determinate"
                        value={69.45}
                        size={160}
                        thickness={3.3}
                        sx={{
                          position: 'absolute',
                          color: 'rgba(255,255,255,.2)'
                        }}
                      />
                      <CircularProgress
                        variant="determinate"
                        value={69.45}
                        size={160}
                        thickness={3.3}
                        sx={{
                          position: 'absolute',
                          color: 'rgba(255,255,255,1)',
                          '& .MuiCircularProgress-circle': {
                            strokeLinecap: 'round'
                          }
                        }}
                      />
                      <Typography
                        variant="h6"
                        component="div"
                        color="rgba(255,255,255,.7)"
                      >
                        69.45%
                      </Typography>
                    </Box>
                  </div>
                  <div className="text-center">
                    <Button
                      size="medium"
                      color="inherit"
                      className="text-uppercase font-size-xs font-weight-bold">
                      Generate report
                    </Button>
                  </div>
                </div>
              </div>
              <Divider />
              <div className="p-4 text-center">
                <h3 className="mb-0 display-3 mt-1 font-weight-bold">
                  $
                  <span className="pr-1">
                    <CountUp
                      start={0}
                      end={458.695}
                      duration={4}
                      separator=""
                      delay={3}
                      decimals={3}
                      decimal=","
                      prefix=""
                      suffix=""
                    />
                  </span>
                </h3>
                <div style={{ height: '120px', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f5f5f5', border: '1px dashed #ccc', marginTop: '10px' }}>
                  <Typography variant="body2" color="textSecondary">
                    Chart Component Removed
                  </Typography>
                </div>
                <Box sx={{ display: 'flex', gap: 4, mt: 3 }}>
                  <Box sx={{ flex: '1 1 50%' }}>
                    <span className="opacity-6 pb-2">Current month</span>
                    <div className="d-flex align-items-center justify-content-center">
                      <span className="font-weight-bold font-size-lg">
                        <small className="opacity-6 pr-1">$</small>
                        46,362
                      </span>
                      <Badge color="secondary" className="ml-2 text-danger">
                        -8%
                      </Badge>
                    </div>
                  </Box>
                  <Box sx={{ flex: '1 1 50%' }}>
                    <span className="opacity-6 pb-2">Last year</span>
                    <div className="d-flex align-items-center justify-content-center">
                      <span className="font-weight-bold font-size-lg">
                        <small className="opacity-6 pr-1">$</small>
                        34,546
                      </span>
                      <Badge color="secondary" className="text-success ml-2">
                        +13%
                      </Badge>
                    </div>
                  </Box>
                </Box>
                <div className="pb-2 pt-4 text-center">
                  <Button size="small" variant="outlined" color="secondary">
                    <span className="btn-wrapper--label">
                      View complete report
                    </span>
                    <span className="btn-wrapper--icon">
                      <ArrowForward />
                    </span>
                  </Button>
                </div>
              </div>
              <Divider />
              <div className="p-4">
                <div className="text-center">
                  <div className="font-weight-bold font-size-lg mb-0 text-black">
                    Tasks
                  </div>
                  <p className="text-black-50">Your daily tasks list</p>
                </div>
                <div className="rounded p-3 bg-secondary">
                  <div className="task-wrapper">
                    <div className="task-item">
                      <div className="align-box-row">
                        <Checkbox className="align-self-center mr-2" />
                        <div>
                          <b>Finish tasks for today</b>
                          <p className="text-black-50 mt-1 mb-0">
                            But I must explain to you how all this mistaken
                            idea.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="task-item">
                      <div className="align-box-row">
                        <Checkbox className="align-self-center mr-2" />
                        <div>
                          <b>Blinded by desire</b>
                          <p className="text-black-50 mt-1 mb-0">
                            A wonderful serenity has taken possession.
                          </p>
                          <div className="timeline-list mt-3">
                            <div className="timeline-item timeline-item-icon">
                              <div className="timeline-item--content">
                                <div className="timeline-item--icon-wrapper bg-danger text-white">
                                  <Diamond />
                                </div>
                                <h4 className="timeline-item--label mb-2 font-weight-bold">
                                  1998
                                </h4>
                                <p>
                                  Bill Clinton's presidential scandal makes it
                                  online.
                                </p>
                              </div>
                            </div>
                            <div className="timeline-item">
                              <div className="timeline-item--content">
                                <div className="timeline-item--icon" />
                                <h4 className="timeline-item--label mb-2 font-weight-bold">
                                  Java exam day
                                </h4>
                                <p>
                                  Bill Clinton's presidential scandal makes it
                                  online.
                                </p>
                                <div className="avatar-wrapper-overlap mt-2 mb-1">
                                  <div className="avatar-icon-wrapper avatar-icon-sm">
                                    <div className="avatar-icon">
                                      <img alt="..." src={avatar1} />
                                    </div>
                                  </div>
                                  <div className="avatar-icon-wrapper avatar-icon-sm">
                                    <div className="avatar-icon">
                                      <img alt="..." src={avatar7} />
                                    </div>
                                  </div>
                                  <div className="avatar-icon-wrapper avatar-icon-sm">
                                    <div className="avatar-icon">
                                      <img alt="..." src={avatar1} />
                                    </div>
                                  </div>
                                  <div className="avatar-icon-wrapper avatar-icon-sm">
                                    <div className="avatar-icon">
                                      <img alt="..." src={avatar2} />
                                    </div>
                                  </div>
                                  <div className="avatar-icon-wrapper avatar-icon-sm">
                                    <div className="avatar-icon">
                                      <img alt="..." src={avatar6} />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="timeline-item">
                              <div className="timeline-item--content">
                                <div className="timeline-item--icon" />
                                <h4 className="timeline-item--label mb-2 font-weight-bold">
                                  Business investor meeting
                                  <span className="text-info ml-2 badge badge-neutral-info">
                                    New
                                  </span>
                                </h4>
                                <p>
                                  Mosaic, the first graphical browser, is
                                  introduced to the average consumer.
                                </p>
                                <div className="mt-3">
                                  <Button size="small" color="primary">
                                    Submit Report
                                  </Button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="task-item">
                      <div className="align-box-row">
                        <Checkbox className="align-self-center mr-2" />
                        <div className="w-100">
                          World among the stalks
                          <p className="text-black-50 mt-1">
                            Who formed us in his own image, and the breath.
                          </p>
                          <List>
                            <ListItem className="bg-white d-flex justify-content-between align-items-center p-4">
                              <div className="w-100">
                                <div className="d-flex flex-wrap justify-content-between mb-2">
                                  <small className="line-height-xs text-uppercase text-muted">
                                    Nov 12, 11:25am
                                  </small>
                                  <small className="line-height-xs text-uppercase text-success">
                                    Due in 12 days
                                  </small>
                                </div>
                                <h6 className="pt-1 pb-1">
                                  <a
                                    href="#/"
                                    onClick={e => e.preventDefault()}>
                                    #56 - Deploy new website
                                  </a>
                                </h6>
                                <p className="mb-3">
                                  This is a dummy text acting ...
                                </p>
                                <div className="d-flex justify-content-between align-items-center">
                                  <Badge color="primary" className="pl-3 pr-3">
                                    Files ready
                                  </Badge>
                                  <div>
                                    <Button size="small" color="primary">
                                      <span className="btn-wrapper--icon">
                                        <Add sx={{ fontSize: 'small' }} />
                                      </span>
                                      <span className="btn-wrapper--label">
                                        Add
                                      </span>
                                    </Button>
                                  </div>
                                </div>
                              </div>
                            </ListItem>
                            <ListItem className="d-flex justify-content-between align-items-center align-content-center pl-1">
                              <Tooltip
                                arrow
                                title="There are 653 new comments available!"
                                placement="top">
                                <Button size="small" color="primary">
                                  <span className="btn-wrapper--icon">
                                    <Chat />
                                  </span>
                                  <span className="btn-wrapper--label ml-1">
                                    653
                                  </span>
                                </Button>
                              </Tooltip>
                              <div>
                                <small className="text-muted mr-1">(21)</small>
                                <Star sx={{ color: '#f39c12', fontSize: '1rem' }} />
                                <Star sx={{ color: '#f39c12', fontSize: '1rem' }} />
                                <Star sx={{ color: '#f39c12', fontSize: '1rem' }} />
                                <Star sx={{ color: '#f39c12', fontSize: '1rem' }} />
                                <Star sx={{ color: '#f39c12', fontSize: '1rem' }} />
                              </div>
                            </ListItem>
                          </List>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Divider />
              <div className="p-4">
                <div className="text-center">
                  <div className="font-weight-bold font-size-lg mb-0 text-black">
                    Latest sales
                  </div>
                  <p className="text-black-50">Latest reports available</p>
                </div>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                  <Box sx={{ flex: { xs: '1 1 100%', md: '1 1 calc(50% - 16px)' } }}>
                    <div className="bg-secondary rounded py-2 px-1">
                      <div className="display-3 text-center line-height-sm text-second text-center d-flex align-items-center pt-3 justify-content-center">
                        <RadioButtonChecked sx={{ fontSize: 'small', color: '#f39c12', marginRight: 1 }} />
                        <div>436</div>
                      </div>
                      <div className="text-black-50 text-center opacity-6 pt-3">
                        <b>+65%</b> increase
                      </div>
                    </div>
                  </Box>
                  <Box sx={{ flex: { xs: '1 1 100%', md: '1 1 calc(50% - 16px)' } }}>
                    <div className="bg-secondary rounded py-2 px-1">
                      <div className="display-3 text-center line-height-sm text-second text-center d-flex align-items-center pt-3 justify-content-center">
                        <ArrowUpward sx={{ fontSize: 'small', color: '#1bc943', marginRight: 1 }} />
                        <div>843</div>
                      </div>
                      <div className="text-black-50 text-center opacity-6 pt-3">
                        <b>-22%</b> decrease
                      </div>
                    </div>
                  </Box>
                </Box>
              </div>
            </PerfectScrollbar>
          </Box>
        </Drawer>
      </Box>
    </Fragment>
  );
}

export default HeaderDrawer;
